export const environment = {
  name: 'dev',
  production: false,
  reCaptcha: {
    siteKey: '{RECAPTCHA_SITE_KEY}',
  },
  apiRoot: '{API_ROOT}',
  websiteBaseUrl: '{WEBSITE_ROOT}',
  dashboardBaseUrl: '{DASHBOARD_ROOT}',
  sentry: {
    dsn: '{SENTRY_DSN}',
    tracePropagationTargets: ['{SENTRY_TRACE_PROPAGATION_TARGET}'],
    replaysSessionSampleRate: 1,
  },
  intercomAppId: '{INTERCOM_APP_ID}',
};
